<template>
  <div class="min-h-screen flex flex-col text-[var(--mt-text)]">

    <!-- Global Header (always visible unless page disables it) -->
    <!-- <AppHeader v-if="showHeader" /> -->

    <!-- Router outlet -->
    <main class="flex-1">
      <RouterView v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </RouterView>
    </main>

    <!-- Cookie consent banner -->
    <CookieBanner />

  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppHeader from '@/components/layout/AppHeader.vue';
import CookieBanner from '@/components/CookieBanner.vue';

const route = useRoute();

// Hide header for Auth pages only
const showHeader = computed(() => {
  return !route.path.startsWith('/auth');
});
</script>

<style>
/* Soft fade animation for routing transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
